import { Link } from 'react-router-dom';

const TONES = {
  // Clean white with a hairline oat border and a soft resting float.
  default: 'bg-surface border-oat-dark shadow-soft',
  raised: 'bg-surface border-oat-dark shadow-crate',
  quiet: 'bg-oat/45 border-oat-dark/60',
  // Leaf tone gets a subtle vertical gradient for a bit of premium depth.
  leaf: 'bg-gradient-to-b from-leaf-700 to-leaf-800 border-leaf-800 text-milk shadow-crate',
  accent: 'bg-persimmon-light border-persimmon/30 shadow-soft',
};

export default function Card({
  tone = 'default',
  to,
  padded = true,
  className = '',
  children,
  ...props
}) {
  const classes = [
    'rounded-crate border',
    TONES[tone] ?? TONES.default,
    padded ? 'p-5 sm:p-6' : '',
    // Linkable cards gently rise on hover (desktop) and press in on tap.
    to
      ? 'block transition-[transform,box-shadow] duration-200 ease-out active:shadow-lift sm:hover:-translate-y-0.5 sm:hover:shadow-lift'
      : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, action, className = '' }) {
  return (
    <div className={`flex items-start justify-between gap-4 ${className}`}>
      <div className="min-w-0">
        <h3 className="font-display text-lg leading-tight text-heading">{title}</h3>
        {subtitle && <p className="mt-1 text-sm text-ink-muted">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
